module.exports = __webpack_public_path__ + "img/40_38_065_240.ec518555.jpg";